module.exports = __webpack_public_path__ + "img/sort-up-down.64be50a1.svg";